import { makeStyles } from "@material-ui/core/styles";

const style = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  inputImage: {
    display: "none",
  },
  paper: {
    width: "30%",
    height: "80vh",
    backgroundColor: theme.palette.background.paper,
  },
  list: {
    maxHeight: "65vh",
    overflow: "auto",
  },
  header: {
    display: "flex",
    width: "30%",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  headerList: {
    paddingLeft: "10px",
    paddingRight: "10px",

    display: "flex",
    justifyContent: "space-between",
    fontWeight: "bold",
  },
  titlePaper: {
    marginTop: theme.spacing(1),
    fontWeight: "bold",
    fontSize: "15px",
    alignItems: "center",
    justifyContent: "center",
  },
  button: {},
}));

export default style;
